import { Params } from "./../../../../node_modules/@types/express-serve-static-core/index.d";
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpParams,
  HttpErrorResponse,
} from "@angular/common/http";
import { IApiBaseActions } from "../Interfaces/apiCall.interface";
import { environment } from "../../../environments/environment";
import { catchError, tap } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class ApiHandlerService implements IApiBaseActions {
  constructor(
    public httpClient: HttpClient,
    private authService: AuthService
  ) {}
  private baseUrl = `${environment.baseUrl}`;
  handleError(error: HttpErrorResponse) {
    let errorMessage = "An error occurred.";
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error

      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      // Provide more specific error messages based on status code or error details
      if (error.status === 0) {
        errorMessage += "\nPossible network connectivity or server issue.";
      } else if (error.status === 404) {
        errorMessage += "\nResource not found.";
      } else if (error.status === 500) {
        errorMessage += "\nInternal server error.";
      }
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  Get(url: string) {
    return this.httpClient.get(`${this.baseUrl}${url}`).pipe(
      tap((x) => this.HandleResponse(x)),
      catchError(this.handleError)
    );
  }

  Post(url: string, data: any, params?: any) {
    return this.httpClient
      .post(`${this.baseUrl}${url}`, data, {
        params,
      })
      .pipe(
        tap((x) => {
          this.HandleResponse(x);
        }),
        catchError(this.handleError)
      );
  }

  Delete(url: string, data: any) {
    return this.httpClient
      .delete(`${this.baseUrl}${url}`)
      .pipe(tap((x) => this.HandleResponse(x)));
  }

  Put(url: string, data: any) {
    return this.httpClient.put(`${this.baseUrl}${url}`, data).pipe(
      tap((x) => {
        this.HandleResponse(x);
      }),
      catchError(this.handleError)
    );
  }

  //  handleError(error: HttpErrorResponse) {
  //   let errorMessage = 'Unknown error!';
  //   if (error.error instanceof ErrorEvent) {
  //     // Client-side errors
  //     errorMessage = `Error: ${error.error.message}`;
  //   } else {
  //     // Server-side errors
  //     errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
  //   }
  //   console.error(errorMessage);
  //   return throwError(errorMessage);
  // }

  HandleResponse(response: any) {
    if (response.Status === 500) {
      //   alert(responseMessage.serverError);
    }
  }
  getRegions(): Observable<any> {
    return this.httpClient.get("https://ipapi.co/json/");
  }
}
